<template>
  <mdb-tbl>
    <mdb-tbl-head>
      <tr>
        <th>교과구분</th>
        <th v-for="i in maxLength" :key="i">
          {{i}}개월차(160H)
        </th>
      </tr>
    </mdb-tbl-head>
    <mdb-tbl-body>
      <tr>
        <th>NCS 소양교과</th>
        <td v-for="i in maxLength" :key="i">
          <p v-for="(l, i) in loadmap.ncsCultures[i-1]" :key="i">{{l.name}}({{l.hours}})</p>
        </td>
      </tr>
      <tr>
        <th>NCS 전공교과</th>
        <td v-for="i in maxLength" :key="i">
          <p v-for="(l, i) in loadmap.ncsSpecials[i-1]" :key="i">{{l.name}}({{l.hours}})</p>
        </td>
      </tr>
      <tr>
        <th>비 NCS 교과</th>
        <td v-for="i in maxLength" :key="i">
          <p v-for="(l, i) in loadmap.nonNcsSpecials[i-1]" :key="i">{{l.name}}({{l.hours}})</p>
        </td>
      </tr>
    </mdb-tbl-body>
  </mdb-tbl>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
export default {
  name: 'TrainingLoadmap',
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['loadmap'],
  data: () => ({
    TAG: 'TrainingLoadmap :'
  }),
  computed: {
    maxLength () {
      if (!this.loadmap) return 0;
      return Math.max(this.loadmap.ncsCultures.length, this.loadmap.ncsSpecials.length, this.loadmap.nonNcsSpecials.length)
    }
  }
}
</script>
<style scoped>
th, td {
  font-size: 14px;
}
</style>
